import styled from "styled-components";
import { COLORS, FONT_FAMILY } from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const FilterRow = styled.div<{ $biggerCursor: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  button {
    cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  }
  @media (max-width: 767px) { width: 100%; gap: 8px; }
`;

export const SelectButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  border: 0;
  border-radius: 24px;
  padding: 8px 16px;
  background: ${COLORS.Cultured};
  color: ${COLORS.RaisinBlack};
  font-family: ${FONT_FAMILY.poppins};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  > span { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  > svg { flex-shrink: 0; }
  &:hover { background: ${COLORS.Background}; }
  &:focus-visible { outline: 2px solid ${COLORS.Yellow}; outline-offset: 2px; }
  @media (max-width: 767px) { font-size: 12px; padding: 8px 10px; }
`;

export const TypeSelect = styled.div`
  > button { width: 100%; }
  @media (max-width: 767px) { flex: 0 0 96px; min-width: 0; }
`;

export const DateControl = styled.div`
  display: flex;
  align-items: center;
  border-radius: 24px;
  background: ${COLORS.Cultured};
  overflow: hidden;
  > button { border-radius: 0; }
  > button[aria-haspopup] { flex: 1; min-width: 0; }
  @media (max-width: 767px) { flex: 1; min-width: 0; }
`;

export const ArrowButton = styled(SelectButton)`
  padding: 8px 6px;
  flex: 0 0 auto;
`;

export const PeriodPicker = styled.div`
  width: 304px;
  max-width: calc(100vw - 48px);
  padding: 16px;
`;

export const PickerYear = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-family: ${FONT_FAMILY.poppins};
  color: ${COLORS.RaisinBlack};
  font-size: 16px;
  font-weight: 600;
`;

export const PeriodOption = styled(SelectButton)<{ $selected: boolean }>`
  width: 100%;
  justify-content: space-between;
  margin-top: 4px;
  border-radius: 12px;
  min-height: 44px;
  background: ${({ $selected }) => $selected ? COLORS.Background : "transparent"};
  color: ${({ $selected }) => $selected ? COLORS.Crimson : COLORS.RaisinBlack};
  font-weight: ${({ $selected }) => $selected ? 600 : 500};
  &:focus-visible { outline-color: ${COLORS.Crimson}; }
`;

export const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px solid ${COLORS.Background};
  > button { margin: 0; justify-content: center; padding: 8px 4px; font-size: 12px; }
`;
